// https://stackoverflow.com/questions/4770025/how-to-disable-scrolling-temporarily
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
import React from 'react';
import { isClientSide } from './ssr';
var SCROLL_KEYS = { ArrowLeft: 1, ArrowUp: 1, ArrowRight: 1, ArrowDown: 1 };
// modern Chrome requires { passive: false } when adding event
var supportsPassive = false;
try {
    // @ts-ignore
    window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
        get: function () { return (supportsPassive = true); },
    }));
}
catch (_a) {
    //
}
var wheelOpt = supportsPassive ? { passive: false } : false;
var wheelEvent = isClientSide && 'onwheel' in document.createElement('div')
    ? 'wheel'
    : 'mousewheel';
export var useDisableScroll = function (params) {
    React.useEffect(function () {
        var preventDefault = function (e) {
            var _a, _b;
            if (params.ignoreRef &&
                e.target &&
                !((_b = (_a = params.ignoreRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.contains(e.target))) {
                e.preventDefault();
            }
        };
        var preventDefaultForScrollKeys = function (e) {
            if (SCROLL_KEYS[e.code]) {
                preventDefault(e);
                return false;
            }
        };
        var disableScroll = function () {
            window.addEventListener('DOMMouseScroll', preventDefault, false);
            window.addEventListener('touchmove', preventDefault, wheelOpt);
            window.addEventListener('keydown', preventDefaultForScrollKeys, false);
            window.addEventListener(wheelEvent, preventDefault, wheelOpt);
        };
        var enableScroll = function () {
            window.removeEventListener('DOMMouseScroll', preventDefault, false);
            window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
            // @ts-ignore
            window.removeEventListener('touchmove', preventDefault, wheelOpt);
            // @ts-ignore
            window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
        };
        if (params.enabled) {
            disableScroll();
        }
        else {
            enableScroll();
        }
        return enableScroll;
    }, [params.ignoreRef, params.enabled]);
};
//# sourceMappingURL=useDisableScroll.js.map